
import { Component, Vue } from "vue-property-decorator";
import { UserRoles } from "@/utils/UserConstants";
import { EMPTY_STRING } from "@/utils/Constants";

import UserDetailsModal from "./components/UserDetailsModal.vue";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue"),
    UserDetailsModal: () => import("./components/UserDetailsModal.vue")
  }
})
export default class Users extends Vue {
  ROLE_ADMIN = UserRoles.ROLE_ADMIN;
  ROLE_REINSURER = UserRoles.ROLE_REINSURER;
  ROLE_SUBSCRIPTOR = UserRoles.ROLE_SUBSCRIPTOR;

  users: any = [];
  userToCreate: any = {
    fullname: EMPTY_STRING,
    firstName: EMPTY_STRING,
    lastName: EMPTY_STRING,
    email: EMPTY_STRING,
    roleId: EMPTY_STRING,
    reinsurerId: EMPTY_STRING,
    businessId: EMPTY_STRING,
    business_type_id: EMPTY_STRING,
    can_do_request: 0,
    mail_notification: 0,
    request_notification: 0,
    claim_notification: 0
  };
  selectedUser: any = null;
  selectedUserId: number = 0;
  validationErrors: any = {
    firstName: false,
    lastName: false,
    email: false,
    roleId: false,
    reinsurerId: false,
    businessId: false,
    business_type_id: false,
  }
  sortColumns: Record<string, string> = {
    name: "Nombre",
    email: "Email",
    type: "Tipo",
  };
  currentSort: Record<string, string> = {
    col: "fullname",
    dir: "asc",
  };
  filter: any = {
    reinsurerId: EMPTY_STRING,
    businessId: EMPTY_STRING,
    business_type_id: EMPTY_STRING,
    roleId: EMPTY_STRING,
    state: EMPTY_STRING
  };
  totalRows: number = 0;
  limit: number = 10;
  reinsurers: any = [];
  businesses: any = [];
  businessTypes: any = [];
  adminRoles: any = [];
  detailsVisible: boolean = false;

  async mounted() {
    await this.loadReinsurers();
    await this.loadBusinesses();
    await this.loadBusinessTypes();
    await this.loadAdminRoles();
    await this.loadUsers(1, this.currentSort);
  }

  clearFilters() {
    Object.keys(this.filter).forEach((key: any) => {
      if (key === "modifyType") this.filter[key] = -1;
      else this.filter[key] = EMPTY_STRING;
    });
    this.loadUsers(1, this.currentSort);
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadUsers(page, this.currentSort);
  }

  async loadUsers(page: number, sort: Record<string, string>) {
    this.currentSort = sort;
    const response: any = await (this.$root as any)._get("users", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      ...this.filter,
       business_type_id: this.isSuper ? this.filter.business_type_id : this.$store.state.user.business_type_id
    });
    this.totalRows = response.totalRows;
    this.users = response.data;
  }

  async handleRefreshUsers() {
    await this.loadUsers(1, this.currentSort);
  }

  async loadReinsurers() {
    const response: any = await (this.$root as any)._get("reinsurers/");
    this.reinsurers = response.data;
  }

  async loadBusinesses() {
    const response: any = await (this.$root as any)._post("businesses/all");
    this.businesses = response.data;
  }

  async loadBusinessTypes() {
    const response: any = await (this.$root as any)._get("business-types/");
    this.businessTypes = response.data;
  }

  async loadAdminRoles() {
    const response: any = await (this.$root as any)._get("admins/getroles");
    this.adminRoles = response;
  }

  showDetailsModal(user: any) {
    this.selectedUser = user;
    (this.$refs.detailsModal as any).show();
  }

  validateData(user: any) {
    const email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let validated = true;

    if (this.isEmpty(user.firstName)) {
      this.validationErrors.firstName = true;
      validated = false;
    } else this.validationErrors.firstName = false;

    if (this.isEmpty(user.lastName)) {
      this.validationErrors.lastName = true;
      validated = false;
    } else this.validationErrors.lastName = false;

    if (this.isEmpty(user.email)) {
      this.validationErrors.email = true;
      validated = false;
    } else this.validationErrors.email = false

    if (user.roleId === EMPTY_STRING) {
      this.validationErrors.roleId = true;
      validated = false;
    } else this.validationErrors.roleId = false;

    if (this.isSuper && user.roleId == this.ROLE_ADMIN.toString() && (user.business_type_id === '')) {
      this.validationErrors.business_type_id = true;
      (this.$root as any).notify("Debe seleccionar un tipo de empresa para el rol administrador SUPER.", "error");
      return false;
    } else {
      this.validationErrors.business_type_id = false;
    }

    if (!validated) {
      (this.$root as any).notify("Hay campos requeridos faltantes. Por favor, verifique y vuelva a intentarlo.", "error")
      return validated;
    }

    if (!email.test(user.email)) {
      this.validationErrors.email = true;
      (this.$root as any).notify("El campo email no tiene un formato correcto. Verifique y vuelva a intentarlo.", "error")
      return false;
    }

    if (user.roleId == this.ROLE_REINSURER.toString() && (user.reinsurerId === null || user.reinsurerId === '')) {
      this.validationErrors.emptyReinsurer = true;
      (this.$root as any).notify("Debe seleccionar una reaseguradora para el rol reasegurador.", "error");
      return false;
    } else {
      this.validationErrors.emptyReinsurer = false;
    }

    if (user.roleId == this.ROLE_SUBSCRIPTOR.toString() && (user.businessId === null || user.businessId === '')) {
      this.validationErrors.emptyBusiness = true;
      (this.$root as any).notify("Debe seleccionar una empresa para el rol suscriptor.", "error");
      return false;
    } else {
      this.validationErrors.emptyBusiness = false;
    }

    return validated;
  }

  async save(user: any) {
    if (this.validateData(user)) {

      try {
        const payload = {
          ...user,
          business_type_id: this.isSuper ? user.business_type_id : this.$store.state.user.business_type_id
        };

        await (this.$root as any)._post(`users`, payload);

        this.loadUsers(1, this.currentSort);
        this.userToCreate = {};

        (this.$root as any).notify(`El usuario fue creado con éxito.`);
      } catch (e: any) {
        let errorMessage;

        switch (e.code) {
          case "EMAIL_EXISTS":
            errorMessage = "Ya existe un usuario con el email ingresado.";
            break;
          case "ADMIN_USER_EXISTS":
            errorMessage = "Ya existe un usuario administrador con el email ingresado";
            break;
          case "SUBSCRIPTOR_USER_EXISTS":
            errorMessage = "El mail ingresado esta asociado a un usuario subscriptor.<br/>Para continuar, elimine el suscriptor o intente con otro email.";
            break;
          case "INVALID_ROLE":
            errorMessage = "El rol ingresado no existe o no es válido";
            break;
          case "NO_REINSURER_SELECTED":
            errorMessage = "Debe seleccionar una reaseguradora para el rol REASEGURADOR.";
            break;
          default:
            errorMessage = `No se pudo crear el usuario.`;
            break;
        }

        (this.$root as any).notify(errorMessage, "error");
      }
    }
  }

  showDeleteModal(id: number) {
    this.selectedUserId = id;
    (this.$refs.modal as any).show();
  }

  async deleteUser() {
    try {
      let response: any = await (this.$root as any)._delete(
        `users/${this.selectedUserId}`
      );
      this.loadUsers(1, this.currentSort);
      (this.$refs.modal as any).hide();
      (this.$root as any).notify("El usuario fue eliminado con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo eliminar el usuario.", "error");
    }
  }

  getName(user: any) {
    if (user.firstName && user.lastName) return `${user.firstName} ${user.lastName}`;
    else if (user.admin) return user.admin.fullname
    else return user.subscriptor.fullname
  }

  getRoleName(roleId: number) {
    if (roleId === this.ROLE_SUBSCRIPTOR) return "Suscriptor"
    if (roleId === this.ROLE_REINSURER) return "Reasegurador"
    return "Administrador"
  }

  getAuthStatus(user: any) {
    const statuses = {
      null: { class: "no-data", text: "Sin datos" },
      1: { class: "pending", text: "Pendiente" },
      2: { class: "pending", text: "Pendiente" },
      3: { class: "active", text: "Activo" }
    };

    if (user.authStatusId >= 4 && user.authStatusId <= 8) {
      return { class: "inactive", text: "Inactivo" };
    }

    return statuses[user.authStatusId] || { class: "unknown", text: "Desconocido" };
  }

  isEmpty(value) { return value.trim().length === 0 }

  get isSuper() {
    return !Boolean(this.$store.state.user.business_type_id);
  }
}

